export const privacyPolicyContent = {
  title: 'Privacy Policy for The Mahj Market',
  effectiveDate: '3/16/2026',
  introduction: [
    'The Mahj Market (“The Mahj Market," "we," "our," or "us") respects your privacy and is committed to protecting the personal information of our buyers, sellers, and visitors. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit or use the Mahj Market website and marketplace platform.',
    'By using The Mahj Market, you agree to the practices described in this Privacy Policy.',
  ],
  sections: [
    {
      heading: '1. Information We Collect',
      paragraphs: [
        'We may collect the following types of information when you use The Mahj Market:',
      ],
      subsections: [
        {
          title: 'Personal Information',
          paragraphs: [
            'When you create an account, purchase products, or list items for sale, we may collect:',
          ],
          listItems: [
            'Name',
            'Email address',
            'Mailing and shipping address',
            'Phone number',
            'Payment information (processed by third-party payment providers)',
            'Account login credentials',
          ],
        },
        {
          title: 'Seller Information',
          paragraphs: ['If you register as a seller, we may also collect:'],
          listItems: [
            'Business name',
            'Tax information where required',
            'Payment payout details',
            'Product listings and descriptions',
          ],
        },
        {
          title: 'Transaction Information',
          paragraphs: ['We collect information related to marketplace transactions including:'],
          listItems: [
            'Products purchased or sold',
            'Order history',
            'Payment confirmations',
            'Shipping information',
          ],
        },
        {
          title: 'Technical Information',
          paragraphs: ['When you visit our website, we may automatically collect:'],
          listItems: [
            'IP address',
            'Browser type',
            'Device information',
            'Pages visited',
            'Time spent on pages',
            'Referral URLs',
          ],
        },
      ],
      closingParagraphs: [
        'This information helps us improve the performance and functionality of Mahj Market.',
      ],
    },
    {
      heading: '2. How We Use Your Information',
      paragraphs: ['We use the information we collect to:'],
      listItems: [
        'Create and manage user accounts',
        'Facilitate marketplace transactions between buyers and sellers',
        'Process payments and issue seller payouts',
        'Provide customer support',
        'Improve our platform and services',
        'Communicate updates, promotions, or service notifications',
        'Detect fraud, abuse, or security issues',
        'Comply with legal obligations',
      ],
    },
    {
      heading: '3. Payment Processing',
      paragraphs: [
        'The Mahj Market does not store full payment card details. Payments are securely processed by third-party payment processors such as Stripe.',
        'These providers may collect payment information directly in accordance with their own privacy policies.',
      ],
    },
    {
      heading: '4. Shipping Services',
      paragraphs: [
        'Sellers may use integrated shipping providers such as Shippo to generate shipping labels and fulfill orders. Shipping information necessary to deliver products may be shared with these services.',
      ],
    },
    {
      heading: '5. How We Share Information',
      paragraphs: ['We may share information in the following circumstances:'],
      subsections: [
        {
          title: 'With Sellers and Buyers',
          paragraphs: [
            'To complete marketplace transactions, necessary order information (such as shipping details) is shared between buyers and sellers.',
          ],
        },
        {
          title: 'With Service Providers',
          paragraphs: [
            'We may share data with trusted third-party providers that assist with:',
          ],
          listItems: [
            'Payment processing',
            'Shipping label generation',
            'Website hosting',
            'Email communications',
            'Analytics',
          ],
          closingParagraphs: [
            'These providers only receive the information necessary to perform their services.',
          ],
        },
        {
          title: 'Legal Requirements',
          paragraphs: [
            'We may disclose information if required by law or if we believe disclosure is necessary to:',
          ],
          listItems: [
            'Comply with legal obligations',
            'Protect the rights and safety of Mahj Market',
            'Prevent fraud or illegal activity',
          ],
        },
      ],
    },
    {
      heading: '6. Cookies and Tracking Technologies',
      paragraphs: [
        'The Mahj Market may use cookies and similar technologies to:',
      ],
      listItems: [
        'Remember user preferences',
        'Improve website performance',
        'Analyze usage and traffic patterns',
      ],
      closingParagraphs: [
        'You can adjust your browser settings to refuse cookies, though some features of the platform may not function properly.',
      ],
    },
    {
      heading: '7. Data Security',
      paragraphs: [
        'We take reasonable administrative, technical, and physical measures to protect your personal information. However, no online system can guarantee complete security.',
      ],
    },
    {
      heading: '8. Data Retention',
      paragraphs: ['We retain user information as long as necessary to:'],
      listItems: [
        'Maintain your account',
        'Comply with legal obligations',
        'Resolve disputes',
        'Enforce marketplace policies',
      ],
    },
    {
      heading: '9. Your Privacy Rights',
      paragraphs: [
        'Depending on your location, you may have the right to:',
      ],
      listItems: [
        'Access your personal information',
        'Request corrections to inaccurate information',
        'Request deletion of your data',
        'Opt out of marketing communications',
      ],
      closingParagraphs: [
        'Requests can be made by contacting us using the information below.',
      ],
    },
    {
      heading: "10. Children's Privacy",
      paragraphs: [
        'The Mahj Market is not intended for individuals under the age of 18, and we do not knowingly collect personal information from children.',
      ],
    },
    {
      heading: '11. Changes to This Policy',
      paragraphs: [
        'We may update this Privacy Policy periodically. Changes will be posted on this page with an updated effective date.',
      ],
    },
    {
      heading: '12. Contact Us',
      paragraphs: [
        'If you have questions about this Privacy Policy or our data practices, please contact:',
      ],
      contact: {
        organization: 'The Mahj Market',
        email: 'support@themahjmarket.com',
        websiteLabel: 'www.themahjmarket.com',
        websiteUrl: 'https://www.themahjmarket.com',
      },
    },
  ],
};

export default privacyPolicyContent;
